import { Field } from '@klarna/bubble-ui';
import { postalCode } from '@klarna/mf-validations';
import { withTooltip, TOOLTIP_MODES } from 'moet-core';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import { CY_ADDRESS_FORM_COMPONENT_IDS, tPrefix } from '../constants';

const { INPUT_POSTAL_CODE } = CY_ADDRESS_FORM_COMPONENT_IDS;

export const postalCodeField = (tMerchantAware, defaultField = {}, country, showTooltip) => ({
  ...defaultField,
  component: withTooltip(Field),
  size: 1,
  type: 'text',
  label: tMerchantAware(`${tPrefix}.postal_code.label`),
  validators: [
    {
      callback: postalCode.validate,
      errorMessage: tMerchantAware(`${tPrefix}.postal_code.error`),
      options: { country },
    },
  ],
  extraProps: {
    ...defaultField.extraProps,
    tooltipText: showTooltip && tMerchantAware(`${tPrefix}.postal_code.tooltip`),
    tooltipMode: TOOLTIP_MODES.HELPER,
    ...generateCyElemId(INPUT_POSTAL_CODE, window),
    isUnderlined: true,
  },
});
